// sortTimelineEntriesByStart.js
//
// Default timeline/Gantt row order: start ascending, then title, then key.

/**
 * @param {object} entry
 * @returns {number}
 */
export function getTimelineEntryStartMs(entry) {
  const start = entry?.range?.start;
  if (!start) return Number.POSITIVE_INFINITY;
  const ms = start instanceof Date ? start.getTime() : new Date(start).getTime();
  return Number.isFinite(ms) ? ms : Number.POSITIVE_INFINITY;
}

/**
 * Compare for Array#sort — start asc, then title, then key (stable-ish).
 *
 * @param {object} a
 * @param {object} b
 * @returns {number}
 */
export function compareTimelineEntriesByStart(a, b) {
  const startA = getTimelineEntryStartMs(a);
  const startB = getTimelineEntryStartMs(b);
  if (startA !== startB) {
    if (!Number.isFinite(startA)) return 1;
    if (!Number.isFinite(startB)) return -1;
    return startA - startB;
  }

  const titleA = String(a?.title || '').trim().toLocaleLowerCase();
  const titleB = String(b?.title || '').trim().toLocaleLowerCase();
  const titleDiff = titleA.localeCompare(titleB);
  if (titleDiff !== 0) return titleDiff;

  return String(a?.key || '').localeCompare(String(b?.key || ''));
}

/**
 * @param {Array<object>} entries
 * @returns {Array<object>}
 */
export function sortTimelineEntriesByStart(entries = []) {
  const list = Array.isArray(entries) ? [...entries] : [];
  list.sort(compareTimelineEntriesByStart);
  return list;
}
